import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cleanHtml'
})
export class CleanHtmlPipe implements PipeTransform {

  transform(value: any): any {
    if (value) {
      return value.replace(/<.*?>/g, '').replace(new RegExp('&([A-Za-z]+|#x[\dA-Fa-f]+|#\d+);', 'g'), '');;
    }
  }

}
